import { createSlice } from "@reduxjs/toolkit";
import { apiCaller } from "../../api/apiCaller";
import { bonusApi } from "../../sharedfiles/EndpointConfig";

export const BonusSlice = createSlice({
  name: "bonusSlice",
  initialState: {
    bonusData: [],
    paginationFirstValue: 1,
    paginationSecondValue: 25,
    errorMessage: "",
    userid: "",
    recordsShow: [1, 25],
    isVisible: false,
    bonusTransactionData: [],
    freeSpinConfig: [],
  },
  reducers: {
    setBonusData: (state, action) => {
      state.bonusData = action.payload;
    },
    setPaginationFirstValue: (state, action) => {
      state.paginationFirstValue = action.payload;
    },
    setPaginationSecondValue: (state, action) => {
      state.paginationSecondValue = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setRecordsShow: (state, action) => {
      state.recordsShow = action.payload;
    },
    setIsVisible: (state, action) => {
      state.isVisible = action.payload;
    },
    setBonusTransactionData: (state, action) => {
      state.bonusTransactionData = action.payload;
    },
    setFreeSpinConfig: (state, action) => {
      state.freeSpinConfig = action.payload;
    },
  },
});

export const {
  setBonusData,
  setPaginationFirstValue,
  setPaginationSecondValue,
  setErrorMessage,
  setRecordsShow,
  setIsVisible,
  setBonusTransactionData,
  setFreeSpinConfig,
} = BonusSlice.actions;

export const getUserFreeSpinConfig = (userBonusId, userId) => (dispatch) => {
  const url = `${bonusApi.getUserFreeSpinConfig}/${userBonusId}/${userId}?pageNumber=0&itemsPerPage=25`;

  return apiCaller(url, "GET")
    .then((response) => {
      console.log("Full API Response:", response);
      if (response && (response.status === "200" || response.status === 200)) {
        const freeSpinData =
          response.data && response.data.data ? response.data.data : [];
        console.log("Extracted freeSpinData:", freeSpinData);
        dispatch(setFreeSpinConfig(freeSpinData));
        return freeSpinData;
      } else {
        console.log("API Response Status:", response?.status);
        throw new Error(`API call failed with status: ${response?.status}`);
      }
    })
    .catch((error) => {
      console.error("Error fetching free spin config:", error);
      dispatch(setFreeSpinConfig([]));
      throw error;
    });
};

export const getBonusTableList =
  (pagenumbervalue, itemperpagevalue, id) => (dispatch) => {
    var url =
      `${bonusApi.getPlayerBonus}` +
      id +
      "/user-bonus" +
      "?itemsPerPage=" +
      itemperpagevalue +
      "&pageNumber=" +
      pagenumbervalue;

    if (id !== "" || id !== null || id !== undefined) {
      apiCaller(url, "GET").then((response) => {
        if (response !== null && response) {
          if (response.status == "200") {
            dispatch(setBonusData(response.data));
            dispatch(setIsVisible(true));
          }

          dispatch(setErrorMessage(response.message));
        }
      }).catch(() => { });
    }
  };

export const bonusTransaction =
  (pageNumber, itemsPerPage, id) => (dispatch) => {
    const url =
      `${bonusApi.getPlayerBonus}` +
      id +
      "/transactions?" +
      "pageNumber=" +
      pageNumber +
      "&itemsPerPage=" +
      itemsPerPage;

    if (id !== null || id !== "" || id !== undefined) {
      apiCaller(url, "GET")
        .then((response) => {
          dispatch(setBonusTransactionData(response.data));
          dispatch(setIsVisible(true));
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

export default BonusSlice.reducer;
